import { Link, useLocation } from "react-router-dom";

export function TopAppBar() {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <header className="fixed top-0 w-full z-50 flex justify-center px-4 py-3 bg-background/95 backdrop-blur-md border-b border-white/10">
      <div className="max-w-[1440px] w-full flex justify-between items-center">
        <div className="flex items-center gap-10">
          <Link to="/hn" className="text-2xl font-extrabold tracking-tight text-white font-headline flex items-center gap-2">
            <span className="w-2 h-8 bg-secondary"></span>
            THE EDITORIAL PULSE
          </Link>
          <nav className="hidden lg:flex items-center gap-8 font-label font-bold text-xs uppercase tracking-widest">
            <Link
              to="/hn/newest"
              className={currentPath === '/hn/newest' ? 'text-secondary border-b-2 border-secondary' : 'text-on-surface-variant hover:text-white transition-colors'}
            >
              New
            </Link>
            <Link
              to="/hn"
              className={currentPath === '/hn' ? 'text-secondary border-b-2 border-secondary' : 'text-on-surface-variant hover:text-white transition-colors'}
            >
              Past
            </Link>
            <Link
              to="/hn/saved"
              className={currentPath === '/hn/saved' ? 'text-secondary border-b-2 border-secondary' : 'text-on-surface-variant hover:text-white transition-colors'}
            >
              Saved
            </Link>
            <Link
              to="/hn/ask"
              className={currentPath === '/hn/ask' ? 'text-secondary border-b-2 border-secondary' : 'text-on-surface-variant hover:text-white transition-colors'}
            >
              Ask
            </Link>
            <Link
              to="/hn/show"
              className={currentPath === '/hn/show' ? 'text-secondary border-b-2 border-secondary' : 'text-on-surface-variant hover:text-white transition-colors'}
            >
              Show
            </Link>
            <Link
              to="/hn/jobs"
              className={currentPath === '/hn/jobs' ? 'text-secondary border-b-2 border-secondary' : 'text-on-surface-variant hover:text-white transition-colors'}
            >
              Jobs
            </Link>
          </nav>
        </div>
        <div className="flex items-center gap-6">
          <Link
            to="/hn/saved"
            className="px-6 py-2 text-xs font-black bg-secondary text-on-secondary hover:bg-white transition-all uppercase tracking-tighter"
          >
            Reading List
          </Link>
        </div>
      </div>
    </header>
  );
}
